import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

import CurrentLanguage from '@/components/CurrentLanguage.vue';
import { BPTQuestion, questionTypes, textRules } from '@/models/bpt.model';
import { useEvents, Event } from '@/services/events.composable';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { NEW_ID } from '@/util/constants';
import { computed, onMounted, PropType, ref, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { BPTStoreActions, BPTStoreState } from '@/stores/bpt.store';
import BPTAnswersField from '@/components/bpt/BPTAnswersField.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BPTQuestionForm',
  props: {
  data: {
    type: Object as PropType<BPTQuestion>,
  },
},
  setup(__props) {

const store = useStore<ShiftCMSState & { bpt: BPTStoreState }>();
const questions = computed<BPTQuestion[]>(() => store.state.bpt.questions);

const events = useEvents();

const props = __props;

const valid = ref<boolean>(false);

const question = ref<BPTQuestion>({
  id: NEW_ID,
  text: '',
  type: '',
  index: 0,
  onboarding: false,
  answers: [],
  ...(props.data || {}),
});

const action = computed<string>(() =>
  question.value.id === NEW_ID ? 'Add' : 'Save',
);

const saveBPTQuestion = async () => {
  let success: boolean = false;
  if (valid.value) {
    if (question.value.id === NEW_ID) {
      success = await store.dispatch(
        BPTStoreActions.AddBPTQuestion,
        question.value,
      );
    } else {
      success = await store.dispatch(
        BPTStoreActions.UpdateBPTQuestion,
        question.value,
      );
    }
  }
  if (success) {
    events.emit(Event.Saved, true);
    store.dispatch(Actions.ShowNotification, {
      message: 'Saved question',
      type: 'success',
    });
    store.commit(Mutations.HideDrawer);
    store.dispatch(BPTStoreActions.GetBPTQuestions);
  }
};

const updateLanguage = async () => {
  if (question.value.id === NEW_ID) {
    Object.assign(question.value, { title: '', type: 'question' });
  } else {
    const q = await store.dispatch(
      BPTStoreActions.GetBPTQuestion,
      question.value.id,
    );

    if (q) {
      Object.assign(question.value, { ...q });
    }
  }
};

onMounted(() => {
  events.on(Event.LanguageChanged, updateLanguage);
  if (props.data) {
    Object.assign(question.value, props.data);
  }
});

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, updateLanguage);
});

const questionTypesFiltered = computed(() =>
  questionTypes.filter(
    (v) => !questions.value.map((q) => q.type).includes(v.value),
  ),
);

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: valid.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((valid).value = $event)),
    onSubmit: _withModifiers(saveBPTQuestion, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, [
            _createTextVNode(_toDisplayString(_ctx.$t(action.value)) + " a question ", 1),
            _createVNode(CurrentLanguage)
          ]),
          _createVNode(_component_v_text_field, {
            modelValue: question.value.text,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((question.value.text) = $event)),
            rules: _unref(textRules),
            label: "Title",
            required: ""
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "8" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    label: "Type",
                    modelValue: question.value.type,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((question.value.type) = $event)),
                    hint: "The type of the question will provide the values for the answers.",
                    items: questionTypesFiltered.value
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    modelValue: question.value.onboarding,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((question.value.onboarding) = $event)),
                    label: "Use in onboarding"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (question.value.type === 'interests')
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 0,
                type: "info"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("The interests question should not have answers.")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (question.value.type === 'location')
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 1,
                type: "info"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("The location question should not have answers.")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(BPTAnswersField, {
            modelValue: question.value.answers,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((question.value.answers) = $event)),
            "question-type": question.value.type
          }, null, 8, ["modelValue", "question-type"]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { col: "2" }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "reset",
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("Reset")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "submit",
                    color: "success",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(action.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { col: "2" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})